import src from "IMAGE";
export default { src, width: 262, height: 64, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAL0lEQVR42m3HMQoAIAwEwYCakMAVd/9/rFEsLYZlDUBUlf9ICiO5ekabz3nPzNsNUpICbEalhU4AAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
